import { useLocation } from 'react-router-dom';

const useQueryStringParams = (key: string) => {
    return new URLSearchParams(useLocation().search).get(key);
};

export { useQueryStringParams };
